import { IonButton, IonText } from "@ionic/react";
import { useContext, useRef, useState } from "react";

import { accountsListEmptySelector } from "#/features/auth/authSelectors";
import { PageContext } from "#/features/auth/PageContext";
import AppContent from "#/features/shared/AppContent";
import { useAppSelector } from "#/store";

import IncognitoSvg from "./incognito.svg?react";

import sharedStyles from "#/features/shared/shared.module.css";
import styles from "./LoggedOut.module.css";
import Login from "../auth/login/login/Login";
import useStartJoinFlow from "../auth/login/pickJoinServer/useStartJoinFlow";

export default function LoggedOut() {
  const connectedInstance = useAppSelector(
    (state) => state.auth.connectedInstance,
  );
  const loginInstance: string = import.meta.env.VITE_CUSTOM_LEMMY_SERVERS;
  const accountsListEmpty = useAppSelector(accountsListEmptySelector);

  const { presentLoginIfNeeded, presentAccountSwitcher } =
    useContext(PageContext);  
  
  const contentRef = useRef<HTMLIonContentElement>(null);
  const startJoinFlow = useStartJoinFlow(contentRef);
  const [submitting, setSubmitting] = useState(false);

  async function submit() {
    setSubmitting(true);

    try {
      await startJoinFlow(loginInstance);
    } finally {
      setSubmitting(false);
    }
  }
  
    // presentActionSheet({
    //   buttons: compact([
    //     {
    //       text: `Join ${selectedUrl}`,
    //       handler: () => {
    //         submit();
    //       },
    //     },
    //   ]),
    // });

  const signupCallback = () => {
    submit();
    presentLoginIfNeeded();
  }

  return (
    <AppContent className={styles.content}>
      <div>
        <IonText color="medium">
          <p className={styles.message}>
            You are browsing <strong>Democrats.com</strong> as a guest.
            Log in to vote, comment and post!
          </p>
        </IonText>
        {/* <IonButton
          className="ion-padding-start ion-padding-end"
          expand="block"
          onClick={() => {
            presentLoginIfNeeded();
          }}
        >
          {accountsListEmpty ? "Get Started" : "Log In"}
        </IonButton>
        {!accountsListEmpty && (
          <IonButton
            className="ion-padding-start ion-padding-end"
            expand="block"
            fill="clear"
            onClick={() => {
              presentAccountSwitcher();
            }}
          >
            Switch Accounts
          </IonButton>
        )} */}
      </div>
      <Login
        url={loginInstance}
        signupCallback={signupCallback}
      />
      {/* <IonButton
        className="ion-padding-start ion-padding-end"
        expand="block"
        onClick={() => {
          submit();
          presentLoginIfNeeded();
        }}
      >
        Sign Up
      </IonButton> */}
      {/* <IncognitoSvg className={sharedStyles.emptyStateIcon} /> */}
    </AppContent>
  );
}
